var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_847_19938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21C2.5 9.95431 11.4543 1 22.5 1C33.5457 1 42.5 9.95431 42.5 21C42.5 32.0457 33.5457 41 22.5 41C11.4543 41 2.5 32.0457 2.5 21Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21C3 10.2304 11.7304 1.5 22.5 1.5C33.2696 1.5 42 10.2304 42 21C42 31.7696 33.2696 40.5 22.5 40.5C11.7304 40.5 3 31.7696 3 21Z",
    stroke: "#D1D1DB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 14.75C23.25 14.3358 22.9142 14 22.5 14C22.0858 14 21.75 14.3358 21.75 14.75V20.25H16.25C15.8358 20.25 15.5 20.5858 15.5 21C15.5 21.4142 15.8358 21.75 16.25 21.75H21.75V27.25C21.75 27.6642 22.0858 28 22.5 28C22.9142 28 23.25 27.6642 23.25 27.25V21.75H28.75C29.1642 21.75 29.5 21.4142 29.5 21C29.5 20.5858 29.1642 20.25 28.75 20.25H23.25V14.75Z",
    fill: "#8A8AA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_847_19938",
    x: 0.5,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0901961 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_847_19938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_847_19938",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCirclePlus);
export default __webpack_public_path__ + "static/media/ic_circle-plus.f5dfa5f4552cc3865a2cf814dc41747b.svg";
export { ForwardRef as ReactComponent };